import { Accordion } from 'react-bootstrap'
import { BsCircleFill } from 'react-icons/bs'

export default function FAQ() {
  return (
    <div className='container' id="faq">
        <div className='row justify-content-center'>
            <div className='col-md-8'>
                <h3 className='text-center text-muted'>سوالات بیشتر متداول</h3>
                <br/>
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <p className='bold m-2 brand-p'>
                                <span className='m-2 text-primary'><BsCircleFill/></span>
                                این پلتفرم چه تفاوتی با سایر سیستم های نرم افزاری دارد ؟
                            </p>
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='brand-p'>عموم نرم افزارها به صورت پیشفرض بر اساس انجام عملیات توسط انسان طراحی شده اند اما هدف ما تسهیل فرایندهای کسب و کار شما بر پایه هوش مصنوعی است.</p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>
                            <p className='bold m-2 brand-p'>
                                <span className='m-2 text-primary'><BsCircleFill/></span>
                                برای نصب و استفاده از پلتفرم چه تجهیزاتی مورد نیاز است ؟
                            </p>
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='brand-p'>یک لپ تاپ ساده متصل به اینترنت داخل کشور ، مسیر شما را برای دسترسی به منابع بزرگ پردازشی  پلتفرم فراهم می کند.</p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>
                            <p className='bold m-2 brand-p'>
                                <span className='m-2 text-primary'><BsCircleFill/></span>
                               آیا پلتفرم در تعداد پرسنل دیجیتال محدودیت دارد ؟
                            </p>
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='brand-p'>  پلتفرم هیچ محدودیتی در تعداد پرسنل دیجیتال نداشته و شما می توانید متناسب با نیاز مجموعه خودتان تعداد پرسنل مورد نیاز را در آن ایجاد نمایید.</p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>
                            <p className='bold m-2 brand-p'>
                                <span className='m-2 text-primary'><BsCircleFill/></span>
                               در زمان قطع اینترنت بین الملل آیا استقاده از پلتفرم با مشکل مواجه میشود ؟
                            </p>
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='brand-p'>این پلتفرم کاملا در زیرساخت داخلی کشور مستقر بوده و تماما توسط مهندسان ما توسعه داده شده است. به همین دلیل حتی در زمان قطع اینترنت بین الملل قابل استفاده است.</p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>
                            <p className='bold m-2'>
                                <span className='m-2 text-primary brand-p'><BsCircleFill/></span>
                               چطور میتوانم عامل هوشمندی که قبلا ایجاد شده، ویرایش و توسعه بدهم ؟
                            </p>
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='brand-p'>تمامی عامل های هوشمند با قابلیت توسعه و ویرایش و نظارت (توسط پنل کاربری) به شما ارائه می شوند. در صورتی که ویرایش مورد نظر شما در چارچوب توسعه قبلی باشد کاملا رایگان بوده و در غیر این صورت، مبلغی به هزینه پردازشی شما افزوده میگردد.</p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                        <Accordion.Header>
                            <p className='bold m-2 brand-p'>
                                <span className='m-2 text-primary'><BsCircleFill/></span>
                              هزینه پردازشگر در عامل هوشمند چیست ؟
                            </p>
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='brand-p'>هوش مصنوعی بر پایه درک و پردازش داده های کلان عمل میکند.  عملیات درک و پردازش داده های کلان بر روی زیرساخت های سخت افزاری و نرم افزاری ویژه ای انجام میشود که لازمست به صورت مستمر پایش شوند.</p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6">
                        <Accordion.Header>
                            <p className='bold m-2 brand-p'>
                                <span className='m-2 text-primary'><BsCircleFill/></span>
                                راه اندازی پلتفرم من چقدر زمان میبرد ؟
                            </p>
                        </Accordion.Header>
                        <Accordion.Body>
                            <p className='brand-p'>پلتفرم مدیریت شما به صورت آنی فعال و قابل استفاده است و هر پرسنل دیجیتال شما بعد از آماده سازی از طریق آن قابل رویت و نظارت است.</p>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>
        </div>
    </div>
  )
}
